import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Start ▸ Run...
 *
 * A dialog rather than a window: no taskbar button, centred on whatever raised
 * it, and fixed at the size the real one was. It is deliberately *not* a
 * singleton — XP would happily give you a second Run box — but nothing in the
 * shell opens it twice, so that never comes up.
 *
 * It takes no args: whatever the user types is the whole input.
 */
export const runApp: AppManifest = {
  id: 'run',
  name: 'Run',
  icon: '/assets/icons/run.svg',
  component: lazy(() => import('./Run')),

  defaultSize: { w: 380, h: 170 },
  resizable: false,
  maximizable: false,
  singleton: false,
  dialog: true,

  // The Start menu and the desktop context menu are its entry points; it has
  // no business sitting in All Programs next to Notepad.
  showInAllPrograms: false,

  titleFor: () => 'Run',
};
